import { render, staticRenderFns } from "./LeadKontaktModal.vue?vue&type=template&id=02d12132"
import script from "./LeadKontaktModal.vue?vue&type=script&lang=js"
export * from "./LeadKontaktModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports